import magicCube from './magicCube'
export const MAGICCUBESTORE = {
  magicCube
}



// WEBPACK FOOTER //
// ./common/commonModule/magicCube/vuex/magicCubeStore.js